import React, { useEffect, useState } from "react";

export default function TypingText({ text = "", speed = 50, onDone, className = "" }) {
  const [shown, setShown] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    setShown("");
    setDone(false);
    if (!text) return;
    let i = 0;
    const id = setInterval(() => {
      i++;
      setShown(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(id);
        setDone(true);
        onDone && onDone();
      }
    }, speed);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, speed]);

  return (
    <span className={`${className} ${done ? "" : "caret"}`} style={{ whiteSpace: "pre-wrap" }}>
      {shown}
    </span>
  );
}
